// 403 and 404 screens (SPEC §7.1): a message and a link to the user's home screen.

import { t } from "../../i18n/i18n";
import type { RouteMatch } from "../../router";
import { createElement, createLink } from "../../ui/dom";
import { startPage } from "../pageFrame";

export async function renderForbiddenPage(container: HTMLElement, route: RouteMatch): Promise<void> {
  renderMessage(container, t("app.forbidden"), route);
  return Promise.resolve();
}

export async function renderNotFoundPage(container: HTMLElement, route: RouteMatch): Promise<void> {
  renderMessage(container, t("app.notFound"), route);
  return Promise.resolve();
}

function renderMessage(container: HTMLElement, message: string, route: RouteMatch): void {
  const page: HTMLElement = startPage(container, message);
  page.append(createElement("p", "muted", route.path), createLink("/", t("app.goHome")));
}
